import HDR from 'constants/httpHeader.const';
import MIME from 'constants/mime.const';
import logger from 'utils/logger.util';

const L = logger('inspectResponse');

const inspectResponse = (response) => {
  if (!(response instanceof Response)) {
    L.warn('()', 'Invalid response:', response);
    return Object.freeze({ invalid: true });
  }

  const { headers, ok, status } = response;

  const json = headers.get(HDR.ct) === MIME.json;
  const text = headers.get(HDR.ct) === MIME.text;

  return Object.freeze({
    //
    ok,
    //
    created: status === 201,
    noContent: status === 204,
    forbidden: status === 403,
    notFound: status === 404,
    methodNotAllowed: status === 405,
    //
    client: 400 <= status && status <= 499,
    server: 500 <= status && status <= 599,
    //
    json,
    text: text || !json,
    //
  });
};

// noinspection JSUnusedGlobalSymbols
export default inspectResponse;
